<template>
  <div class="employees-list">
    <div class="employees-cards mt-3">
      <b-row>
        <div class="mb-5 col-4">
          <b-form-input
            v-model="search"
            type="text"
            class="form-input"
            placeholder="بحث "

          />
        </div>
        <vue3-datatable
          skin="bh-table-bordered "
          paginationInfo=""
          :rows="getRowsType"
          :columns="columns"
          :showPageSize="false"
          :totalRows="employeesList.count"
          showNumbers
          pagination
          :isServerMode="true"
          @change="changeServer"
        >
          <template #actions="data">
            <div class="flex gap-4">
              <div class="icon theme-color">
                <i class="fas fa-phone-volume"></i>
              </div>
              <router-link
              v-if="type==='employees'"
                :to="{ name: 'show-employee', params: { id: data.value.id } }"
              >
                <vue-feather size="16" stroke="blue" type="eye"></vue-feather>
              </router-link>
              <router-link
              v-else
                :to="{ name: 'show-trainer', params: { id: data.value.id } }"
              >
                <vue-feather size="16" stroke="blue" type="eye"></vue-feather>
              </router-link>
            </div>
          </template>
          <template #certified="data">
            <div v-if="data.value.certifications">
                <span v-if="data.value.certifications.length>0" >معتمد</span>
                <span v-else class="text-danger" >غير معتمد</span>

            </div>

          </template>
          <template #nationality="data">
            <div v-if="data.value.nationality">
                <span >{{ data.value.nationality.name }}</span>

            </div>

          </template>
        </vue3-datatable>
      </b-row>
    </div>
  </div>
</template>

  <script>
import Vue3Datatable from "@bhplugin/vue3-datatable";
import "@bhplugin/vue3-datatable/dist/style.css";

export default {
  components: { Vue3Datatable },
  name: "EmployeesList",
  props: {
    employeesList: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => [],
    },
    type:{
      type: String,
      default:'employees'
    }

  },

  data() {
    return {
      search: null,
      rows:[]
    };
  },
  watch: {
    search(newSearch, oldSearch) {
      if (newSearch !== oldSearch) {
        this.$emit("search", newSearch); // Emit the search event to the parent
      }
    },
  },

  computed: {
    getRowsType(){
     if(this.type==='employees'){
      return this.employeesList.employees
     }else{
      return this.employeesList.trainers
     }
    },
    filteredEmployees() {
      // Filter employees based on the search input
      if (!this.search) {
        return this.employeesList;
      }

      const searchTerm = this.search.toLowerCase();
      return this.employeesList.filter((employee) =>
        this.columns.some((column) => {
          const key = column.key;
          const value = employee[key];
          return value && value.toLowerCase().includes(searchTerm);
        })
      );
    },
  },
  methods: {
    changeServer({ current_page  }) {
      this.$emit("page-change", current_page );
    },
  },
};
</script>

  <style lang="">
</style>
